import {SpecificsLabel} from './specifics-label.model';

export class SpecificsLabelWrapper {
  specificsLabels: SpecificsLabel[] = [];

  getAggregatedLabel(): string {
    let aggregatedLabel = '';
    this.specificsLabels.forEach((label) => {
      aggregatedLabel += label.getFormattedLabel() + '\n';
    });

    if (aggregatedLabel && aggregatedLabel !== '') {
      return aggregatedLabel;
    }
  }

}
